<template>
    <div>
        <router-view></router-view>
        <b-row>
            <b-col cols="12" style="margin-top: 15px;">
                <new-date-time-picker label-cols-lg="1" :model="dateTime" @update:model="updateDateTime" label="Tanggal" />
                <p>DateTime Output : {{ dateTime }}</p>
            </b-col>
            <b-col><vue-timepicker @open="setDefaultTime"></vue-timepicker></b-col>
            <!-- <b-col cols="12" style="margin-top: 15px;">
                <new-time-picker label-cols-lg="1" :model="dateTime2" label="Waktu" @update:model="updateDateTime2" />
                <p>Time Output : {{ dateTime2 }}</p>
            </b-col>
            <b-col cols="12" style="margin-top: 15px;">
                <app-input-textbox id="fieldset-" type="number" label-cols-lg="1"  label="Durasi" label-for="input-" size="sm" :model.sync="duration" :isRequired="true" />
                <p>Duration Output : {{ duration }} Menit</p>
            </b-col> -->
        </b-row>
        <b-row style="margin-top: 15px; justify-content: center;">
            <b-button-group size="sm">
                <b-btn @click="() => ( $router.push({ name: 'playgroundpopupmodal', params : { type: 'datetime'} }))" variant="success">DateTime Modal</b-btn>
                <!-- <b-btn @click="() => ( $router.push({ name: 'playgroundpopupmodal', params : { type: 'time'} }))" variant="info">Time Modal</b-btn> -->
                <!-- <b-btn @click="() => ( $router.push({ name: 'playgroundpopupmodal', params : { type: 'duration'} }))" variant="danger">Duration Modal</b-btn> -->
            </b-button-group>
            <!-- <b-col cols="4">
                <b-btn @click="() => ( $router.push({ name: 'playgroundpopupmodal', params : { type: 'datetime'} }))" variant="success">DateTime Modal</b-btn>
            </b-col>
            <b-col cols="4">
                <b-btn @click="() => ( $router.push({ name: 'playgroundpopupmodal', params : { type: 'duration'} }))" variant="danger">Duration Modal</b-btn>
            </b-col> -->
        </b-row>
    </div>
</template>


<script>

import NewDateTimePicker from '@/components/AppInputDateTimePickerCustomPineda.vue';
import NewTimePicker from '@/components/AppInputTimePickerPineda.vue';
import AppInputTextbox from '@/components/AppInputTextbox.vue';
import VueTimepicker from 'vue2-timepicker';

export default {
    components: {
        NewDateTimePicker,
        NewTimePicker,
        AppInputTextbox,
        VueTimepicker
    },
    data() {
        return {
            dateTime: null,
            dateTime2: '',
            duration: '0'
        }
    },
    methods: {
        setDefaultTime() {
            console.log("test focus");
        },
        updateDateTime(newDateTimeValue) {
            //console.log("new date time value", newDateTimeValue);
            this.dateTime = newDateTimeValue;
        },
        updateDateTime2(newDateTimeValue) {
            //console.log("new date time value", newDateTimeValue);
            this.dateTime2 = newDateTimeValue;
        }
    }
}

</script>